// Shared metric names, units and colors for ROS and service director.
export const INTEREST_METRICS=[
    {key:'avg_score',legacyKey:'vibe',label:'Индекс интереса',color:'#0052FF',unit:'',max:100},
    {key:'visits_pct',legacyKey:'visits',label:'Открытия',color:'#FF7438',unit:'%',max:100},
    {key:'scroll_pct',legacyKey:'scroll',label:'Дошли до конца',color:'#7C3AED',unit:'%',max:100},
    {key:'photos_pct',legacyKey:'photos',label:'Фото',color:'#F59E0B',unit:'%',max:100},
    {key:'actions_pct',legacyKey:'actions',label:'Клики связи',color:'#059669',unit:'%',max:100},
    {key:'avg_time_min',legacyKey:'time',label:'Ср. активное время',color:'#6B7280',unit:' с',max:null},
]
